<template>
	<div id="kcchuru">

		<div class="fflex ffbet" style="margin-bottom: 10px">
			<ul class="fflex headBox">
				<li @click="jump('kcshanglei')">库存列表</li>
<!--				<li @click="jump('kcbaobiao')">库存报表</li>-->
				<li @click="jump('kcpand')">盘点单</li>
				<li class="active">出入库明细</li>

			</ul>
			<div class=" ">

			</div>
		</div>

		<div class="fflex ffend" style="margin: 10px 0;line-height: 32px;color: #999">
			<el-date-picker size="small" style="width: 215px;margin-right: 10px" v-model="setime" :name="['time_s','time_e']"
			 type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期">
			</el-date-picker>
			<!--<span style="margin-right: 5px">类别名称:</span>-->

			<select name="" class="xiala " v-model="type_id" style="width: 120px;margin-right: 10px;margin-left: 5px">
				<option value="">类别名称</option>
				<option :value="ty.id" v-for="ty in types">{{ty.type_name}}</option>


			</select>

			<!--<el-select size="small" style="width:115px;margin-right: 10px"  v-model="goodslei" placeholder="选择商品类别">-->
			<!--<el-option-->
			<!--v-for="item in goodsleiop"-->
			<!--:key="item.value"-->
			<!--:label="item.label"-->
			<!--:value="item.value">-->
			<!--</el-option>-->
			<!--</el-select>-->

			<!--<span style="margin-right: 5px">业务类别:</span>-->

			<select name="" class="xiala " v-model="order_type" style="width: 120px;margin-right: 10px;margin-left: 5px">
				<option value="">业务类别</option>
				<option value="1">入库</option>
				<option value="2">出库</option>
				<!--<option :value="go.user_id" v-for="go in goodsleiop">{{go.username}}</option>-->


			</select>


			<el-input size="small" placeholder="输入商品名称" v-model="search"  @keyup.enter.native="chaxun" style="width: 150px;margin-right: 10px"></el-input>
			<el-button type="success" size="mini" @click="chaxun">查询</el-button>
		</div>
		<div class="fflex ffend" style="margin-bottom: 10px">
			<a :href="baseUrl + 'saas/JxcStock/exportdetails?centre_id='+centre_id" target="_blank">
				<button type="button" class="el-button purBtnsz el-button--primary el-button--mini is-round" style="height: 28px;"><span>导出列表</span></button>
			</a>
		</div>

		<div class="tableBox">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th>序号</th>

						<th>订单编号</th>

						<th>商品编号</th>
						<th>商品名称</th>
						<th>图片</th>
						<th>类别名称</th>
						<th>商品规格</th>
						<th>单位</th>
<!--						<th>价格</th>-->
						<th>业务类别</th>
						<th>入库数量</th>
						<th>出库数量</th>
<!--						<th>入库金额</th>-->
<!--						<th>出库金额</th>-->
					</tr>
				</thead>
				<tbody>
					<tr v-for="(ta,taindex) in tabledata" :key="taindex">
						<td>{{taindex+1}}</td>
						<th>{{ta.order_num}}</th>
						<td>{{ta.good_num}}</td>
						<td>{{ta.good_name}}</td>
						<td><img class="miniimg" :preview="taindex+1" :src="ta.imgpath"></td>
						<td>{{ta.type_name}}</td>
						<td>{{ta.spec}}</td>
						<td>{{ta.unit}}</td>
<!--						<td>{{ta.price}}</td>-->
						<td>{{ta.storage_name}}</td>
						<td>{{ta.enter_number}}</td>
						<td>{{ta.out_number}}</td>
<!--						<td>{{ta.enter_price}}</td>-->
<!--						<td>{{ta.out_price}}</td>-->


					</tr>

				</tbody>
			</table>
			<p>共有4条记录 当前1页/共1页</p>
		</div>

		<div class="table-bottom">
			<div>
				<el-pagination @current-change="handleCurrentChange" :current-page="currentpage" :page-size="pageone" background
				 layout="prev, pager, next" :total="total">
				</el-pagination>
			</div>
		</div>







	</div>
</template>

<script>
	export default {
		data() {
			return {
				setime: '',
				token: '',
				gyshang: '',
				currentpage: 1,
				pageone: 10,
				total: 100,
				kcchurut: false,
				zhuang: '',
				Ttitle: '',
				dis: false,
				//            shangphone:''
				goodsleiop: [{
					value: '',
					label: '请选择类别'
				}, {
					value: '195',
					label: '非消耗品'
				}, {
					value: '196',
					label: '日常消耗品'
				}, {
					value: '197',
					label: '固定资产'
				}],
				yewuleiop: [{
					value: '',
					label: '请选择业务类'
				}, {
					value: '195',
					label: '非消耗品'
				}, {
					value: '196',
					label: '日常消耗品'
				}, {
					value: '197',
					label: '固定资产'
				}],
				goodslei: '',
				yewulei: '',
				search: '',
				type_id: '',
				order_type: "",
				tabledata: '',
				types: '',
				centre_id: '',
				baseUrl: ''
			};
		},
		created() {
			this.baseUrl = process.env.apiUrl
		},
		methods: {

			//        daochu:function () {
			//            let self=this;
			//            $.ajax({
			//                type: 'POST',
			//                url:process.env.apiUrl + 'saas/JxcStock/exportdetails',
			//                dataType:'json',
			//                data:{
			//
			//                    token:self.token,
			//
			//
			//                },
			//                success:function (data) {
			//
			//
			//                }
			//            })
			//        },
			chaxun: function() {
				let self = this;
				self.currentpage = 1;
				self.gonggong()
			},
			handleCurrentChange: function(i) {
				let self = this;
				self.currentpage = i;
				self.gonggong()
			},

			jump: function(e) {
				this.$router.push({
					'name': e
				})
			},
			gonggong: function() {

				var self = this;
				self.time_s = $("input[name='time_s']").val()
				self.time_e = $("input[name='time_e']").val()
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + 'saas/JxcStock/stockdetails',
					dataType: 'json',
					data: {
						page: self.currentpage,
						token: self.token,
						search: self.search,
						time_s: self.time_s,
						time_e: self.time_e,
						type_id: self.type_id,
						order_type: self.order_type

					},
					success: function(data) {
						self.centre_id = data.centre_id
						if (data.status == 1) {
							self.tabledata = data.data;
							self.total = Number(data.map.count)
							self.currentpage = Number(data.map.page)
							self.pagetotal = Number(data.map.pagetotal)
							self.types = data.types;
						} else {
							self.tabledata = '';
							self.total = 0;
							self.pagetotal = 1;
							self.currentpage = 1
						}
					}
				})
			}



		},
		mounted: function() {
			var self = this;
			self.token = $.cookie('token');
			self.gonggong()


		}


	}
</script>

<style scoped>
	.xiala {
		width: 200px;
		height: 32px;
		line-height: 32px;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: 13px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

	}

	.miniimg {
		width: 25px;
		height: 25px;
	}

	.yulantu {
		width: 100px;
		height: 100px;
		border-radius: 6px;
		margin-left: 10px;
	}

	ul {
		list-style: none;
	}

	#kcchuru p,
	label,
	ul {
		margin: 0;
		padding: 0;
	}

	.fflex {
		display: flex;
		display: -webkit-flex;
	}

	.ffbet {
		justify-content: space-between;
	}

	.ffend {
		justify-content: flex-end;
	}

	#kcchuru * {
		box-sizing: border-box;
	}

	#kcchuru {
		box-sizing: border-box;
		padding: 10px;
	}

	.headBox li {
		width: 75px;
		background: #8CBB77;
		height: 30px;
		line-height: 30px;
		margin-right: 8px;
		border-radius: 5px 5px 0 0;
		text-align: center;
		color: #fff;

	}

	.headBox li.active {
		background: #ecebfd;
		color: #8CBB77;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
	}

	.purBtnsz {
		background: #8CBB77 !important;
		height: 26px;
		border: none !important;
	}

	.marBo2 {
		margin-bottom: 10px;
	}

	.inputT {
		display: inline-block;
		width: 100px;

	}
</style>
<style>


</style>



// WEBPACK FOOTER //
// src/pages/jinxc/kcchuru.vue